function nav() {
  const $window = $(window);
  const $header = $('header');
  const $toggler = $('.navbar-toggler');
  const $menu = $('#main-menu');
  const $backdrop = $('.backdrop');

  const headerOffset = 100;
  const activeOffset = 200;

  function closeMenu() {
    $toggler.removeClass('open').attr('aria-expanded', 'false');
    $menu.removeClass('open');
    $backdrop.removeClass('open');
  }

  function toggleMenu(event) {
    event.preventDefault();

    $toggler.toggleClass('open');
    $menu.toggleClass('open');
    $backdrop.toggleClass('open');

    const isOpen = $menu.hasClass('open');
    $toggler.attr('aria-expanded', isOpen ? 'true' : 'false');
  }

  function updateHeaderState() {
    if ($window.scrollTop() > 0) {
      $header.addClass('fixed');
    } else {
      $header.removeClass('fixed');
    }
  }

  function scrollToSection(targetId) {
    const targetSection = document.querySelector(targetId);

    if (!targetSection) return;

    const topOffset =
      targetSection.getBoundingClientRect().top +
      window.pageYOffset -
      headerOffset;

    window.scrollTo({
      top: topOffset,
      behavior: 'smooth'
    });
  }

  function activateMenuLink(activeLink) {
    if (!activeLink) return;

    $menu.find('a[href^="#"]').removeClass('active');
    activeLink.classList.add('active');
  }

  function updateActiveMenuLink() {
    const currentPos = window.scrollY;
    const sections = document.querySelectorAll('section[id]');

    sections.forEach(section => {
      const topOffset = section.offsetTop - activeOffset;
      const bottomOffset = topOffset + section.offsetHeight;

      if (currentPos >= topOffset && currentPos < bottomOffset) {
        const targetId = '#' + section.getAttribute('id');
        const targetLink = document.querySelector(
          '#main-menu a[href="' + targetId + '"]'
        );

        if (targetLink) {
          activateMenuLink(targetLink);
        }
      }
    });
  }

  function isHomePage() {
    return window.location.pathname === '/';
  }

  $toggler.off('click.nav').on('click.nav', toggleMenu);

  $window.off('scroll.navHeader').on('scroll.navHeader', updateHeaderState);
  updateHeaderState();

  if (isHomePage()) {
    $menu.find('a[href^="#"]').off('click.navAnchor').on('click.navAnchor', function (event) {
      event.preventDefault();

      const targetId = this.getAttribute('href');

      closeMenu();
      scrollToSection(targetId);
      activateMenuLink(this);
    });

    $window.off('scroll.navActive').on('scroll.navActive', updateActiveMenuLink);
    updateActiveMenuLink();

    if (window.location.hash) {
      setTimeout(() => {
        scrollToSection(window.location.hash);

        const targetLink = document.querySelector(
          '#main-menu a[href="' + window.location.hash + '"]'
        );

        activateMenuLink(targetLink);
      }, 100);
    }
  } else {
    $menu.find('a[href^="#"]').off('click.navAnchor').on('click.navAnchor', function (event) {
      event.preventDefault();

      const targetId = this.getAttribute('href').substring(1);
      const targetUrl = window.location.origin + '/#' + targetId;

      closeMenu();

      window.location.href = targetUrl;
    });
  }
}

export { nav };
